import { RadioSelect } from '@/components/common'
import { Option } from '@/components/common/Form/types'
import classNames from 'classnames'
import * as React from 'react'
import { ComponentProps, useState } from 'react'
import { useDropdownClickOutside } from '../../Dropdown/useDropdownClickOutside'

type RadioOptionPickerProps = {
    name: string
    label: React.ReactNode
    value: string
    className?: string
    options: Option<string>[]
    onChange: (value: string) => void
    renderLabel: (option: Option) => React.ReactNode
    description?: React.ReactNode
} & Pick<
    ComponentProps<typeof RadioSelect>,
    | 'renderValueLabel'
    | 'enableDefaultSelection'
    | 'noValueLabel'
    | 'defaultValue'
>

export const RadioOptionPicker: React.FC<RadioOptionPickerProps> = ({
    name,
    label,
    value,
    noValueLabel,
    defaultValue,
    enableDefaultSelection,
    options,
    className,
    onChange,
    renderLabel,
    renderValueLabel,
    description,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const { buttonRef, dropdownRef } = useDropdownClickOutside(() => {
        if (isOpen) {
            setIsOpen(false)
        }
    })

    const handleOptionSelect = (selectedValue: string) => {
        onChange(selectedValue)
        setIsOpen(false)
    }

    const handleDropdownToggle = () => {
        setIsOpen((prev) => !prev)
    }

    return (
        <RadioSelect
            name={name}
            label={label}
            isOpen={isOpen}
            noValueLabel={noValueLabel}
            defaultValue={defaultValue}
            enableDefaultSelection={enableDefaultSelection}
            description={description}
            renderLabel={renderLabel}
            renderValueLabel={renderValueLabel}
            onClick={handleDropdownToggle}
            options={options}
            value={value}
            onChange={handleOptionSelect}
            dropdownRef={dropdownRef}
            buttonRef={buttonRef}
            buttonWrapperClassname="w-full"
            matchReferenceWidth={true}
            buttonClassname={classNames('w-full', className)}
            dropdownClassname={classNames('w-full')}
            itemWrapperClassname="!items-start px-4 py-2 pt-1"
            dropdownOffset={0}
            radioClassName="mt-1"
        />
    )
}
